import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/[locale]/discover-search/components/DiscoverSearchRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/Cohesion/index.tsx");
